import Api from 'app/services/Api'

/**
 * gets articles for blog main page
 */
export const getArticles = (
  params: BlogQueryParams
): Promise<BlogPaginationArticlesModel> =>
  Api.get('/api/v1/blogs/articles', { params, deserialize: true })

/**
 * gets all article categories existing
 */
export const getCategories = (): Promise<BlogCategoryModel[]> =>
  Api.get('/api/v1/blogs/categories', { deserialize: true })

/**
 * gets all article categories existing
 */
export const getTags = (): Promise<BlogTagModel[]> =>
  Api.get('/api/v1/blogs/tags', { deserialize: true })

/**
 * gets single article by slug
 */
export const getArticleBySlug = (
  slug: string
): Promise<BlogArticleDetailModel> =>
  Api.get(`/api/v1/blogs/articles/${slug}`, { deserialize: true })

/**
 * get blog category slugs for sitemap
 */
export const getBlogCategorySlugs = (): Promise<{ slugs: string[] }> =>
  Api.get('/api/v1/sitemaps/blogs/category_slugs')

/**
 * get blog tag slugs for sitemap
 */
export const getBlogTagSlugs = (): Promise<{ slugs: string[] }> =>
  Api.get('/api/v1/sitemaps/blogs/tag_slugs')

/**
 * get blog article slugs for sitemap
 */
export const getBlogArticleSlugs = (): Promise<{
  slugs: {
    slug: string
    category_slug: string
  }[]
}> => Api.get('/api/v1/sitemaps/blogs/article_slugs')
